/**
 * Component Entry
 *
 */

import Accordion from './Accordion'
export default Accordion
export * from './Accordion'
